module.exports = __webpack_public_path__ + "static/media/IMG_0801.8c75999e.jpg";